module.exports = __webpack_public_path__ + "img/support_d3.3026a42c.png";